import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '@/locales/en';
import cn from '@/locales/cn';
import my from '@/locales/my';

Vue.use(VueI18n);

const messages = {
  en: en,
  zh: cn,
  my: my
};

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: messages,
  silentTranslationWarn: true
  // numberFormats: {
  //   en: {
  //     currency: {
  //       style: "currency",
  //       currency: "VND",
  //       currencyDisplay: "code"
  //     }
  //   }
  // },
  // dateTimeFormats: {
  //   en: {
  //     short: {
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       second: "2-digit",
  //       hour12: false
  //     },
  //     long: {
  //       year: "numeric",
  //       month: "short",
  //       day: "numeric",
  //       weekday: "short",
  //       hour: "numeric",
  //       minute: "numeric",
  //       second: "numeric",
  //       hour12: true
  //     }
  //   }
  // }
})

export default i18n;